module.exports = __webpack_public_path__ + "img/SpaceConcept.c8739c4c.webp";